export const THEMES = {
  midnight: {
    name:"Sakura Night", nameRu:"Сакура Ночь",
    bg:"#0d0810", bg2:"#130c1a", bg3:"#1a1024",
    card:"#1a1025", card2:"#221535",
    cardTop: "rgba(19, 12, 26, 0.85)",
    border:"rgba(255,138,195,0.18)",
    accent:"#ff6eb4", accent2:"#d44f8e", accent3:"#ffb3d9",
    accentGlow:"rgba(255,110,180,0.28)", accentDim:"rgba(255,110,180,0.08)",
    amber:"#ffcdd2", amberDim:"rgba(255,182,193,0.12)",
    text:"#f5e6f0", muted:"#8e7a9a",
    gradient:"linear-gradient(135deg, #ff6eb4, #d44f8e)",
  },
  obsidian: {
    name:"Lavender Dream", nameRu:"Сон Лаванды",
    bg:"#09080f", bg2:"#100e1a", bg3:"#161428",
    card:"#141228", card2:"#1c1a38",
    cardTop: "rgba(16, 14, 26, 0.85)",
    border:"rgba(186,140,255,0.18)",
    accent:"#ba8cff", accent2:"#8b5cf6", accent3:"#dbbfff",
    accentGlow:"rgba(186,140,255,0.28)", accentDim:"rgba(186,140,255,0.08)",
    amber:"#ffd6e7", amberDim:"rgba(255,182,193,0.12)",
    text:"#ede8ff", muted:"#7c6aaa",
    gradient:"linear-gradient(135deg, #ba8cff, #8b5cf6)",
  },
  ember: {
    name:"Peach Blossom", nameRu:"Персиковый Цвет",
    bg:"#0f090c", bg2:"#1a0d12", bg3:"#21101a",
    card:"#1e1018", card2:"#2a1520",
    cardTop: "rgba(26, 13, 18, 0.85)",
    border:"rgba(255,150,170,0.18)",
    accent:"#ff96aa", accent2:"#e05575", accent3:"#ffccd8",
    accentGlow:"rgba(255,150,170,0.28)", accentDim:"rgba(255,150,170,0.08)",
    amber:"#ffd6e7", amberDim:"rgba(255,193,210,0.12)",
    text:"#fff0f3", muted:"#9a7080",
    gradient:"linear-gradient(135deg, #ff96aa, #e05575)",
  },
  dark: {
    name:"Pure Dark", nameRu:"Тёмная",
    bg:"#0f0f10", bg2:"#161618", bg3:"#1c1c1f",
    card:"#1a1a1d", card2:"#212125",
    cardTop: "rgba(22, 22, 24, 0.9)",
    border:"rgba(255,255,255,0.08)",
    accent:"#e8e8e8", accent2:"#aaaaaa", accent3:"#ffffff",
    accentGlow:"rgba(255,255,255,0.12)", accentDim:"rgba(255,255,255,0.05)",
    amber:"#f0b429", amberDim:"rgba(240,180,41,0.12)",
    text:"#e8e8e8", muted:"#666680",
    gradient:"linear-gradient(135deg, #3a3a4a, #555570)",
  },
  ocean: {
    name:"Deep Ocean", nameRu:"Глубокий Океан",
    bg:"#060c14", bg2:"#0a1420", bg3:"#0e1c2e",
    card:"#0d1a2a", card2:"#112236",
    cardTop: "rgba(10, 20, 32, 0.88)",
    border:"rgba(79,195,247,0.18)",
    accent:"#4fc3f7", accent2:"#0288d1", accent3:"#b3e5fc",
    accentGlow:"rgba(79,195,247,0.28)", accentDim:"rgba(79,195,247,0.08)",
    amber:"#80deea", amberDim:"rgba(128,222,234,0.12)",
    text:"#e0f7ff", muted:"#5c8a9e",
    gradient:"linear-gradient(135deg, #4fc3f7, #0288d1)",
  },
};